export default "__VITE_ASSET__DVdmo3l0__"